import { Box, Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { formatTime } from '@utils/time/timeUtils';

export default function ChapterNavigation({ chapters, onChapterClick }) {
  if (!chapters || chapters.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Chapters
      </Typography>
      <List disablePadding>
        {chapters.map((chapter, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => onChapterClick(chapter.start)}
              aria-label={`Jump to chapter ${chapter.title}`}
              sx={{ minHeight: 48, px: { xs: 1, sm: 2 } }}
            >
              <ListItemText
                primary={chapter.title}
                secondary={formatTime(chapter.start)}
                primaryTypographyProps={{
                  sx: { overflowWrap: 'anywhere' }
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
